import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { browserHistory } from 'react-router';

import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';

import FlatButton from 'material-ui/FlatButton';
import { List } from 'material-ui/List';
import DetailView from '../Common/DetailView';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import AssignmentIcon from 'material-ui/svg-icons/action/assignment-ind';
import SettingsIcon from 'material-ui/svg-icons/action/settings';

import FilterListItem from '../Filter/FilterListItem';
import ProgrammeListItem from '../Programme/ProgrammeListItem';
import Dialog from 'material-ui/Dialog';
import { statusColours } from '../../constants/ColourConstants';

import AssignmentStore, { getCompliance, getProgramme } from '../../stores/AssignmentStore';
import AssignmentActions from '../../actions/AssignmentActionCreator';
import SuccessSnackbar from '../Common/SuccessSnackbar';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import ComplianceListItem from '../Compliance/ComplianceListItem';

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const Assignment = React.createClass({

    getInitialState: function() {

        return {
            id: '',
            name: '',
            description: '',
            status: 'enrolled',
            requirement: 1,
            type: 'delegate',
            auto: false,
            schedule: '',
            filter: {
                id: '',
                name:'Filter',
                description: 'No filter found',
            },
            programme: null,
            requirementOptions: [
                {id: 1, name: 'mandatory'},
                {id: 2, name: 'optional'},
            ],
            actions: [],
            links: {
                back: '/dashboard/assignments',
                edit: '',
            },
            dialog: {
                open: '',
                value: null,
                check: true,
            }
        }
    },

    getMenuItems: function() {
        return [
            {
                link: '/dashboard/assignment/' + this.props.routeParams.id + '/manage',
                icon: <SettingsIcon />,
                label: 'Manage',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'divider'
            },
            {
                link: '/dashboard/assignment/' + this.props.routeParams.id + '/edit',
                icon: <EditIcon />,
                label: 'Edit',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.props.routeParams.id,
                title: 'Delete',
                deleteAction: (id) => { AssignmentActions.delete(id); browserHistory.goBack(); },
                message: (<span>Delete assignment?</span>),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    componentWillMount: function() {
        this.setState( assign({}, this.state, {
            actions: buildContextMenu(this.getMenuItems(), this.context.auth)})
        );
    },

    componentDidMount: function() {
        AssignmentStore.addChangeListener(this.onChange);
        AssignmentActions.getById(this.props.routeParams.id);
        this.onChange();
    },

    componentWillUnmount: function() {
        AssignmentStore.removeChangeListener(this.onChange);
    },

    render: function() {

        const colour = statusColours['default'];
        const avatarIcon = (<AssignmentIcon style={style.icon} color={colour}/>);

        let dialog = '';
        if (this.state.dialog.open !== '') {
            const dialogProps = {open: true, onRequestClose: this.closeDialog};
            let submitButtonLabel = "Submit";
            switch (this.state.dialog.open) {
                case 'assign':
                    dialogProps.title = "Run assignment";
                    submitButtonLabel = "Run";
                    dialogProps.children = (<span>Run this assignment now?</span>);
                    break;
                default:
                    console.error('unhandled dialog ' + this.state.dialog.open);
                    dialogProps.open = false;
                    break;
            }
            if (dialogProps.open) {
                dialogProps.actions = [
                    <FlatButton label="Cancel" onTouchTap={this.closeDialog} />,
                    <FlatButton label={submitButtonLabel} onTouchTap={this.submitDialog} disabled={this.state.dialog.value === null} primary={true} />
                ];
                dialog = <Dialog {...dialogProps} />
            }
        }

        const requirement = this.state.requirementOptions.find(el => el.id === this.state.requirement);

        return (
            <DetailView
                title=''
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={this.state.name}
                            subtitle={this.state.description}
                            avatar={avatarIcon}
                        />
                        <CardText className='cent-card-text'>
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Type: </em>{this.state.type}</li>
                                        <li><em>Status: </em>{this.state.status}</li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Requirement: </em>{requirement.name || ''}</li>
                                        <li>{!!this.state.auto ? `Set to run at ${this.state.schedule} daily` : ''}</li>
                                    </ul>
                                </div>
                            </div>
                        </CardText>
                        <List>
                            <FilterListItem data={this.state.filter} />
                            {this.state.programme && <ProgrammeListItem data={this.state.programme} />}
                            {this.state.compliance && <ComplianceListItem {...this.state.compliance} />}
                        </List>
                        {this.context.auth.isAdmin() && (
                            <CardActions>
                                <FlatButton label="Run" onTouchTap={this.onAssign} primary={true} />
                            </CardActions>
                        )}
                    </Card>
                </div>
                {dialog}
                <SuccessSnackbar message="Assignment will be run shortly."/>
            </DetailView>
        )
    },

    onChange: function() {
        const assignment = AssignmentStore.getById(Number(this.props.routeParams.id));
        if (assignment !== undefined) {
            this.setState({
                id: assignment.id,
                name: assignment.name,
                description: assignment.description,
                requirement: assignment.requirement,
                auto: assignment.auto,
                schedule: assignment.schedule,
                filter: {
                    id:          assignment.filterId,
                    name:        assignment.filterName,
                    description: assignment.filterDescription,
                    count:       assignment.filterMatches
                },
                programme: getProgramme(assignment),
                compliance: getCompliance(assignment)
            });
        }
    },

    onAssign: function() {
        this.openDialog('assign', this.props.routeParams.id);
    },

    openDialog: function(dialog, value) {
        if (value === undefined) { value = null; }
        this.setState({dialog: {open: dialog, value: value}});
    },

    submitDialog: function() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'assign':
                AssignmentActions.run(this.state.dialog.value);
                break;
            default:
                console.error('Error: unhandled dialog ' + this.state.dialog.open);
                break;
        }
        if (close) { this.closeDialog(); }
    },

    closeDialog: function() {
        this.setState({dialog: {open: ''}});
    }

});

Assignment.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Assignment;
